<template>
  <div class="input-options">
    <label
      v-for="option in options"
      :key="option.value"
      class="input-option-item"
      :class="{
        '-use-acceent': useAccent,
        '-checked': option.value === modelValue,
        '-regular': !isSmall,
        '-small': isSmall,
      }"
      :style="{
        '--accent': option.accent,
      }"
    >
      <input
        type="radio"
        :name="name"
        :value="option.value"
        :checked="option.value === modelValue"
        @input="$emit('update:modelValue', option.value)"
      >
      <BaseIcon
        v-if="option.icon"
        :icon="option.icon"
      />
      <span
        v-else
        v-text="option.label"
      />
    </label>
  </div>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  options: {
    type: Array,
    default: () => [],
  },
  name: {
    type: String,
    default: () => {
      const uid = Math.random().toString().substring(2, 12);
      return `radio-uid-${uid}`;
    },
  },
  useAccent: {
    type: Boolean,
    default: false,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
});

</script>

<style scoped>
.input-options {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  --accent: var(--gray-800);
}

.input-option-item {
  background-color: var(--gray-100);
  border: 1px solid var(--gray-200);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius);
  min-width: 60px;
  cursor: pointer;
  &.-use-acceent {
    color: var(--accent);
  }
  &.-checked {
    background-color: var(--accent);
    color: var(--white);
  }
  &.-regular {
    flex: 1;
    height: 64px;
    font-size: 32px;
    font-weight: 700;
  }
  &.-small {
    height: 60px;
    font-size: 20px;
    font-weight: 400;
  }
  & input {
    display: none;
  }
}
</style>
